<style lang="scss">
    .buy-license-modal {
        overflow : scroll !important;

        .item-media-content{
            width : 100%;
            border-radius: 5px;
        }

        .terms-license{
            cursor: pointer;
        }

        .beat-name{
            font-size: 22px;
            color: #363C43;
        }
        .license-box-container {
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
            .license-box {
                -webkit-box-flex: 1;
                flex-grow: 1;
                width: 120px;
                .license-price {
                    border-radius: 5px;
                    height: 60px;
                    padding-top: 5px 5px 5px 0;
                    text-align: center;
                    height: 50px;
                    cursor: pointer;
                    font-size: 12px;
                    margin: 5px;
                }
            }
        }

        .pricing-row-beat-container{
            padding-top: 5px;
            padding-bottom: 5px;
            margin-left: 0px;
            margin-right: 0px;
            margin-bottom: 30px;

            .item-media{
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
                border-radius: 5px !important;
                height: 52px;
                width: 52px;
                overflow: inherit !important;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .item-title {
                font-family: Poppins;
                font-weight: 600;
                font-size: 14px !important;
                background: none !important;
                text-overflow : ellipsis;
                margin-left: 10px;
                margin-top: 25px;
            }

            .item-media-colomn{
                overflow: hidden;
                padding-left: 0px !important;
                padding-right: 0px !important;
            }
        }

        .licenses-wrapper {
            display: flex;
            margin-left: -10px;
            margin-right: -10px;
            margin-bottom: 40px;
            .beat-license-container {
                flex: 1;
                max-width: 180px;
                min-width: 175px;
                margin: 10px 10px;
                height: 100%;
                border: none;
                &:hover {
                    border: none;
                }

                .best-offer {
                    cursor: pointer;
                }
                .flex-wrapper{
                    padding: 0px 0 !important;
                    display: flex;
                }
                .license-container{
                    cursor: pointer;
                    min-height: 170px;
                }
                .buy-button, .discounts-box {
                    width: calc(100% + 10px);
                    left: -5px;
                }
            }
            &.max-licenses {
                .beat-license-container {
                    margin-left: 5px;
                    margin-right: 5px;
                    min-width: 175px;
                }
            }
        }

        .mobile-licenses-wrapper {
            .mobile-beat-license-container {
                border: none;
                .buy-button, .discounts-box-mobile {
                    width: calc(100% + 8px);
                    left: -4px;
                }
            }
        }

        .note{
            color: #595e63;
            font-family: Poppins;
            font-size: 11px;
            font-weight: 400;
        }

        @media screen and (max-width: 1100px) {
            .licenses-wrapper {
                &.max-licenses {
                    margin-left: -20px;
                    margin-right: -20px;
                    .beat-license-container {
                        min-width: 138px;
                        margin-left: 5px;
                        margin-right: 5px;
                        .license-container {
                            min-height: 170px;
                        }
                        .license-name {
                            font-size: 12px;
                        }
                        .price {
                            font-size: 24px;
                        }
                        .file-type-wrapper {
                            font-size: 12px;
                        }
                        .buy-button {
                            font-size: 12px;
                            .full-wrapper {
                                width: 70% !important;
                            }
                            .discount-icon-wrapper {
                                width: 30%;
                            }
                        }
                    }
                }
            }
        }

        @media screen and (max-width: 768px) {
            .mobile-licenses-wrapper {
                margin-bottom: 40px;
                .mobile-beat-license-container {
                    margin-bottom: 20px;
                }
            }
        }
        @media screen and (max-width: 543px) {
            .pricing-row-beat-container{
                border-bottom: none;
            }
            .item-media-colomn{
                display: flex;
                flex-direction: column;
                .item-media{
                    width: 100% !important;
                    height: auto;
                }
                .item-title{
                    font-size: 16px !important;
                    margin-left: 0px !important;
                    margin-top: 0px !important;
                    white-space: unset !important;
                }
            }
        }
    }
</style>


<template>
    <div class="buy-license-modal modal fade" id="buyLicenseModal" ref="buy-license-modal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg row-cell v-m">
                <div class="row">
                    <div class="col-md-12 col-lg-10 offset-lg-1">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12" v-if="beat">
                                    <h4 class="modal-title" :style="$highlightColor">PRICING & LICENSES</h4>
                                    <div class="row pricing-row-beat-container">
                                        <div class="col col-md-12 col-sm-12 col-xs-12 item-media-colomn hidden-xs-down">
                                            <div class="item-media" >
                                                <div class="item-media-content" :style="{'background-image': 'url(' +  beat.image(50) + ')'}"></div>
                                            </div>
                                            <div class="item-title text-ellipsis">
                                                {{beat.name}}
                                            </div>
                                        </div>

                                        <div class="col col-md-12 col-sm-12 col-xs-12 item-media-colomn hidden-sm-up">
                                            <div class="item-media" >
                                                <div class="item-media-content" :style="{'background-image': 'url(' +  beat.image(300) + ')'}"></div>
                                            </div>
                                            <div class="item-title text-ellipsis">
                                                {{beat.name}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row actions">
                                        <div class="col-xs-12 col-sm-12 col-md-12">
                                            <div class="licenses-wrapper hidden-sm-down" :class="{'max-licenses': beat.activeLicenses >= 4}">
                                                <template v-for="price in beat.orderedPricing()" v-if="price.license.isAllowedOffers() || price.isSaleable()">
                                                    <license-row class="hidden-sm-down" :beat="beat" :price="price" :collapseId="'modal-'+price.license.id" :key="price.license.id" v-on:license-added="closeModal()"></license-row>
                                                </template>
                                            </div>

                                            <div class="mobile-licenses-wrapper hidden-md-up row">
                                                <template v-for="price in beat.orderedPricing()" v-if="price.license.isAllowedOffers() || price.isSaleable()">
                                                    <mobile-license-row class="hidden-md-up" :beat="beat" :price="price" :collapseId="'modal-'+price.license.id"
                                                                        :key="price.license.id" v-on:license-added="closeModal()"></mobile-license-row>
                                                </template>
                                            </div>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
		
	</div>

</template>

<script>
    import Configure from '../../mixins/configure'
    import LicenseRow from './../beat/licenserow.vue'
    import MobileLicenseRow from './../beat/mobilelicenserow.vue'

    export default {
        components: {
            LicenseRow, MobileLicenseRow
        },
        props: {
            beat: {
                type: Object,
                default: () => (null),
            }
        },
        mixins: [Configure],
        methods: {
            closeModal() {
                $(this.$refs['buy-license-modal']).modal('hide');
            }
        }
    }
</script>